<template>
  <v-dialog
    v-model="state"
    max-width="500"
    persistent
    content-class="elevation-0"
  >
    <v-card
      fluid
      class="card-container"
    >
      <v-card-title class="tab-header">
        <v-row
          no-gutters
          align="center"
        >
          <v-col class="pa-0">
            <v-icon
              color="#FFF9C4"
              size="32"
            >
              mdi-information-variant-circle-outline
            </v-icon>
            <b class="ml-1 text-center text-header"> ดาวน์โหลดไฟล์: {{ round }}</b>
          </v-col>
          <v-col
            cols="auto"
            sm="auto"
            md="auto"
            class="pa-0"
          >
            <v-btn
              depressed
              icon
              color="#FFF9C4"
              @click="closeModal()"
            >
              <v-icon size="32"> mdi-close </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-actions>
        <v-row class="mt-7" justify="center" align="center">
          <v-col cols="auto" class="d-flex align-center">
            <span>ประเภทประกาศนียบัตร</span>
          </v-col>
          <v-col cols="auto" class="pl-5">
            <v-autocomplete
              auto-select-first
              dense
              outlined
              rounded
              hide-details
              id="roundNameType"
              item-text="text"
              item-value="value"
              :items="listTypeRoundNanme"
              :style="{ width: roundNameType === 'unit' ? '150px' : '210px' }"
              v-model="roundNameType"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-actions class="pt-7 pb-6">
        <v-row justify="center">
          <v-btn
            height="40"
            depressed
            rounded
            @click="downloadFile()"
            color="rgb(60,86,147)"
            class="confirm-btn"
            :loading="loading"
          >
            ยืนยัน
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      required: true,
      default: false,
    },
    round: {
      type: String,
    },
    round_id: {
      type: String,
    }
  },
  data: () => ({
    loading: false,
    file: undefined,
    certificateRound: undefined,
    roundNameType: 'origin',
    listTypeRoundNanme:[
      { text:'รูปแบบเดิม',value: "origin"},
      { text:'รูปแบบ 2567',value: "new"},
      { text:'รูปแบบ 2568',value: "new_2568"},
    ],
  }),
  methods: {
    closeModal() {
      this.roundNameType = "origin";
      this.$emit("updateDownloadGenCertificated");
    },
    async downloadFile() {
      this.loading = true
      try {
        const config = {
          url: `${process.env.VUE_APP_API_URL}/register_round/api/v1/download_certificate`,
          responseType: "blob",
          params: {
            round: this.round_id,
            type: this.roundNameType
          },
        };
        const data = await this.axios(config);
        if (data.data) {
          const url = window.URL.createObjectURL(data.data);
          const a = document.createElement("a");
          a.style = "display: none";
          a.href = url;
          a.download = `${this.round}.zip`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } else {
          throw new Error();
        }
        if (data["status"]) {
          this.closeModal();
        } else {
          throw new Error(data["message"]);
        }
      } catch (error) {
        console.log(error);
        
        // if(data.message === 'have no data for download') data.message = 'ไม่พบข้อมูลที่สามารถดาวน์โหลด'
        const errorMsg = error?.message ?? error;
        console.log(errorMsg);
        this.alertError(
          "ดาวน์โหลดไฟล์ไม่สำเร็จ!<br />กรุณาลองใหม่อีกครั้ง"
        );
      } finally {
        this.loading = false;
      }
    },
    alertError(html = "", timer = 4000) {
      this.$swal({
        icon: "error",
        html,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        customClass: {
          htmlContainer: "alert-text",
        },
      });
    },
  },
};
</script>

<style scoped>
* {
  color: #000;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: "Noto Sans Thai", sans-serif !important;
}

.row {
  padding: 0;
  margin: 0;
  width: 100% !important;
  box-sizing: border-box !important;
}

.card-container {
  padding: 0;
  border-radius: 18px;
}

.tab-header {
  padding: 8px 12px !important;
  color: #fff9c4;
  background-color: rgb(60, 86, 147);
}

.text-header {
  color: #fff9c4;
}

.upload-input-file >>> .v-input__control > .v-input__slot {
  min-height: auto;
  padding: 0 16px;
  margin-bottom: 4px;
}

.upload-input-file >>> .v-input__control > .v-text-field__details {
  margin-bottom: 0px;
}

.upload-input-file
  >>> .v-input__control
  > .v-input__slot
  > .v-input__append-inner {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.input-text >>> .v-input__control > .v-input__slot {
  min-height: auto;
  padding: 0 16px;
  margin-bottom: 4px;
}

.input-text >>> .v-input__control > .v-text-field__details {
  margin-bottom: 0px;
}

.confirm-btn {
  color: #fff;
  font-size: 20px;
  padding: 0 36px !important;
  font-weight: 700;
  letter-spacing: 0.5px;
}

@media only screen and (max-width: 37.5em) {
  .card-text-container {
    padding: 12px !important;
  }
}

@media only screen and (max-width: 25em) {
  .text-header,
  .confirm-btn {
    font-size: 18px;
  }
}
</style>
